// extracted by mini-css-extract-plugin
export default {"HiringStages":"styles_HiringStages__oOeCE"};